import { render, staticRenderFns } from "./TableCollapse.vue?vue&type=template&id=8d9d0d96&scoped=true&"
import script from "./TableCollapse.vue?vue&type=script&lang=ts&"
export * from "./TableCollapse.vue?vue&type=script&lang=ts&"
import style0 from "./style.scss?vue&type=style&index=0&id=8d9d0d96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9d0d96",
  null
  
)

export default component.exports